import stickyNav from "./components/sticky-nav";

// import flickityFade from "./components/flickity-fade";
import flickity from "./components/flickity";
import hamburger from "./components/hamburger";
import heroDropdown from "./components/heroDropdown";
import headerDropdown from "./components/headerDropdown";
import lazyLoad from "./components/lazy-load";
import carouselBlock from "./components/carouselBlock";
import glightbox from "./components/glightbox";
import map from "./components/map";
import customDropdown from "./components/customDropdown";
import tabs from "./components/tabs";
import infinitescroll from "./components/infinitescroll";
import searchBar from "./components/searchBar";


import productFinder from "./apps/product-finder";
import resourcesPage from "./apps/resources-page";
import testimonial from "./components/testimonial";
import PathwaysFilter from "./components/PathwaysFilter";

document.addEventListener("DOMContentLoaded", () => {
  stickyNav();
  hamburger();
  heroDropdown();
  headerDropdown();
  // flickity();
  lazyLoad();
  carouselBlock();
  glightbox()
  map();
  customDropdown();
  productFinder();
  tabs();
  infinitescroll();
  searchBar();
  testimonial();
  // flickityFade();

  resourcesPage();
  PathwaysFilter();
});
